define('../app/fukit/configuration/routes.configuration',['require','exports','module','underscore','backbone.radio','../helpers/route.helper','appkit/controller.service'],function(require, exports, module) {
  //prettier-ignore
  var _                 = require('underscore'),
      Radio             = require('backbone.radio'),
      RouteHelper       = require('../helpers/route.helper'),
      controllerService = require('appkit/controller.service');

  var RouteConfiguration = function() {
    var routes = this.routes || {};

    _.each(
      routes,
      function(definition, routePath) {
        definition || (definition = {});
        if (definition.redirect) {
          if (!controllerService.getRouter()) {
            return;
          }
          controllerService.getRouter().route(routePath, function() {
            Backbone.history.navigate(definition.redirect, { trigger: true, replace: true });
          });
          return;
        }
        controllerService.route(
          routePath,
          _.result(definition, 'name'),
          _.result(definition, 'controller'),
          definition.stateDefaults
        );
      },
      this
    );

    // make route helper aware of the router
    RouteHelper.register(controllerService.options.router);
  };

  module.exports = RouteConfiguration;
});

